import React from 'react';
import { ShieldCheck } from 'lucide-react';

// FSA-style Food Hygiene Rating badge. Only renders for numeric ratings 0-5.
const HygieneBadge = ({ rating, className = '' }) => {
  if (rating === undefined || rating === null || rating === '') return null;
  const n = parseInt(String(rating).trim(), 10);
  if (Number.isNaN(n) || n < 0 || n > 5) return null;
  const color = n >= 4 ? 'bg-[#00703C]' : n >= 2 ? 'bg-[#E58A00]' : 'bg-[#D4351C]';
  return (
    <span
      className={`inline-flex items-center gap-1 ${color} text-white text-[11px] font-bold px-2 py-0.5 rounded ${className}`}
      title={`Food Hygiene Rating: ${n} out of 5`}
      data-testid="hygiene-badge"
    >
      <ShieldCheck className="h-3 w-3" />
      {n}/5
    </span>
  );
};

export default HygieneBadge;
